<script>
export default {
  name: 'TwoStepVerificationDeactivateForm',
  data() {
    return {
      code: '',
    };
  },
};
</script>

<template>
  <div class="two-step-verification-deactivate-form">
    <p class="text-warning">
      {{ $t('SETTINGS.TWO_STEP_VERIFICATION.DEACTIVATE_WARNING') }}
    </p>
    <p>{{ $t('SETTINGS.TWO_STEP_VERIFICATION.DEACTIVATE_HELP') }}</p>

    <ElInput
      v-model="code"
      type="code"
      dir="ltr"
      name="code"
      maxlength="6"
      class="text-center"
      autocomplete="off"
      placeholder="# # #   # # #"
    />

    <div class="two-step-verification-deactivate-form__actions">
      <ElButton
        icon="el-icon-close"
        type="default"
        @click="$emit('cancel-click')"
      >
        {{ $t('CANCEL') }}
      </ElButton>

      <ElButton
        icon="el-icon-unlock"
        type="danger"
        :disabled="!code"
        @click="$emit('confirm-click', code)"
      >
        {{ $t('SETTINGS.TWO_STEP_VERIFICATION.DEACTIVATE') }}
      </ElButton>
    </div>
  </div>
</template>

<style lang="scss">
.two-step-verification-deactivate-form {
  margin: auto;

  &__actions {
    margin-top: $global-margin;
  }
}
</style>
